// Runs a large import in sequential chunks so the UI can show a real % progress.
// postChunk(chunkRows, batchId, offset) must return the response data object.
// On a chunk failure it stops and returns { failed: true, processed, error } with
// the counts committed so far (earlier chunks are already persisted server-side).
export async function runChunkedImport({ rows, chunkSize = 1000, postChunk, onProgress }) {
  const batchId = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  const total = rows.length;
  const agg = { created: 0, updated: 0, skipped: 0, skipped_missing: 0, skipped_duplicate: 0, error_count: 0, import_log_id: null };
  const keys = ["created", "updated", "skipped", "skipped_missing", "skipped_duplicate", "error_count"];
  let done = 0;
  onProgress?.(total === 0 ? 100 : 0, 0, total);
  for (let i = 0; i < total; i += chunkSize) {
    const chunk = rows.slice(i, i + chunkSize);
    let data;
    try {
      data = await postChunk(chunk, batchId, i);
    } catch (err) {
      return { ...agg, batchId, failed: true, processed: done, error: err };
    }
    keys.forEach((k) => { if (data && data[k] != null) agg[k] += data[k]; });
    if (data && data.import_log_id) agg.import_log_id = data.import_log_id;
    done += chunk.length;
    onProgress?.(Math.round((done / total) * 100), done, total);
  }
  return { ...agg, batchId, failed: false, processed: done };
}
